import axios from 'axios';
import { getAxiosError, formatFilters } from 'components/utils/helpers';
import {
  SET_SAVEDSEARCH_ERROR,
  SET_SAVEDSEARCH_LOADING,
  ADD_SAVEDSEARCH,
  // UPDATE_SAVEDSEARCH,
  REMOVE_SAVEDSEARCH,
  SET_SAVEDSEARCHES,
  FILTER_DISPLAY_SEARCHES,
  RESET_DISPLAY_SEARCHES,
  SET_SAVEDSEARCH_FILTER,
} from '../reducers/savedsearch';

const START_FILTERING_LENGTH = 2;
const TIMEOUT = process.env.SIGNIN_TIMEOUT || 10000;

export const setSavedSearchLoading = (loading = true) => ({
  type: SET_SAVEDSEARCH_LOADING,
  data: { loading },
});

export const setSavedSearchError = error => ({
  type: SET_SAVEDSEARCH_ERROR,
  data: { error },
});

export const clearSavedSearchError = () => async (dispatch) => {
  dispatch(setSavedSearchError(false));
};

export const addSavedSearch = savedSearch => ({
  type: ADD_SAVEDSEARCH,
  data: { savedSearch },
});

// export const updateSavedSearch = savedSearch => ({
//   type: UPDATE_SAVEDSEARCH,
//   data: { savedSearch },
// });

export const removeSavedSearch = id => ({
  type: REMOVE_SAVEDSEARCH,
  data: { id },
});

export const setSavedSearches = savedSearches => ({
  type: SET_SAVEDSEARCHES,
  data: { savedSearches },
});

export const setFilter = filter => (dispatch) => {
  dispatch({
    type: SET_SAVEDSEARCH_FILTER,
    data: { filter },
  });
};

export const fetchSavedSearches = () => async (dispatch, getState) => {
  const { savedsearch: { savedSearches, loading } } = getState();
  if (savedSearches.length || loading) {
    return;
  }

  dispatch(setSavedSearchLoading());
  try {
    const { data: searches } = await axios.get('/api/searches', { timeout: TIMEOUT });

    dispatch(setSavedSearches(searches));
  } catch (err) {
    const { message } = getAxiosError(err);
    dispatch(setSavedSearchError(message));
  }
};

export const addNewSavedSearch = name => async (dispatch, getState) => {
  try {
    const { query, filters } = getState().search;
    const queryParams = {
      query,
      filters: { ...formatFilters(filters) },
    };

    const { savedsearch: { savedSearches } } = getState();
    // we can be saving a new search before the searches are fetched
    if (!savedSearches.length) {
      dispatch(fetchSavedSearches());
    }
    dispatch(setSavedSearchLoading());
    const { data: { id } } = await axios.post('/api/searches', { name, queryParams }, { timeout: TIMEOUT });
    dispatch(addSavedSearch({ id, name, queryParams }));
    return id;
  } catch (err) {
    const { message } = getAxiosError(err);
    dispatch(setSavedSearchError(message));
    return false;
  }
};

// TODO: modifying saved search is removed form modal pending better ux design - keeping is here commented out for recycling
// export const modifySavedSearch = (id, name) => async (dispatch, getState) => {
//   dispatch(setSavedSearchLoading());
//
//   try {
//     const { query, filters } = getState().search;
//     const { value, displayValue } = formatQuery(query);
//     const queryParams = {
//       query: value,
//       displayValue,
//       filters: { ...destructureFilters(filters) },
//     };
//
//     await axios.put(`/api/searches/${id}`, { name, queryParams }, { timeout: TIMEOUT });
//     dispatch(updateSavedSearch({ id, name, queryParams }));
//     return id;
//   } catch (err) {
//     const { message } = getAxiosError(err);
//     dispatch(setSavedSearchError(message));
//     return false;
//   }
// };

export const filterDisplaySearches = filter => ({
  type: FILTER_DISPLAY_SEARCHES,
  data: { filter },
});

export const resetDisplaySearches = () => ({
  type: RESET_DISPLAY_SEARCHES,
});

export const filterSavedSearches = filter => (dispatch) => {
  if (filter.length < START_FILTERING_LENGTH) {
    dispatch(resetDisplaySearches());
  } else {
    dispatch(filterDisplaySearches(filter));
  }
};

export const deleteSavedSearch = id => async (dispatch) => {
  dispatch(setSavedSearchLoading());
  try {
    await axios.delete(`/api/searches/${id}`, { timeout: TIMEOUT });
    dispatch(removeSavedSearch(id));
    return true;
  } catch (err) {
    const { message } = getAxiosError(err);
    dispatch(setSavedSearchError(message));
    return false;
  }
};
